import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { URI } from '../../../base/common/uri.js';
import { Range } from '../../common/core/range.js';
import { IModelService } from '../../common/services/modelService.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { ITextModelService } from '../../common/services/resolverService.js';
import { OutlineModel, OutlineElement } from '../documentSymbols/outlineModel.js';
import { CommandsRegistry } from '../../../platform/commands/common/commands.js';
import { assertType } from '../../../base/common/types.js';
import { Iterable } from '../../../base/common/iterator.js';
export function getDocumentSymbols(document, flat, token) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var model, roots, _iterator, _step, child, flatEntries;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return OutlineModel.create(document, token);

          case 2:
            model = _context.sent;
            roots = [];
            _iterator = _createForOfIteratorHelper(model.children.values());

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                child = _step.value;

                if (child instanceof OutlineElement) {
                  roots.push(child.symbol);
                } else {
                  roots.push.apply(roots, _toConsumableArray(Iterable.map(child.children.values(), function (child) {
                    return child.symbol;
                  })));
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            flatEntries = [];

            if (!token.isCancellationRequested) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", flatEntries);

          case 9:
            if (flat) {
              flatten(flatEntries, roots, '');
            } else {
              flatEntries = roots;
            }

            return _context.abrupt("return", flatEntries.sort(compareEntriesUsingStart));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function compareEntriesUsingStart(a, b) {
  return Range.compareRangesUsingStarts(a.range, b.range);
}

function flatten(bucket, entries, overrideContainerLabel) {
  var _iterator2 = _createForOfIteratorHelper(entries),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var entry = _step2.value;
      bucket.push({
        kind: entry.kind,
        tags: entry.tags,
        name: entry.name,
        detail: entry.detail,
        containerName: entry.containerName || overrideContainerLabel,
        range: entry.range,
        selectionRange: entry.selectionRange,
        children: undefined
      });

      if (entry.children) {
        flatten(bucket, entry.children, entry.name);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

CommandsRegistry.registerCommand('_executeDocumentSymbolProvider', function (accessor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var resource, model, reference;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            resource = args[0];
            assertType(URI.isUri(resource));
            model = accessor.get(IModelService).getModel(resource);

            if (!model) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", getDocumentSymbols(model, false, CancellationToken.None));

          case 5:
            _context2.next = 7;
            return accessor.get(ITextModelService).createModelReference(resource);

          case 7:
            reference = _context2.sent;
            _context2.prev = 8;
            _context2.next = 11;
            return getDocumentSymbols(reference.object.textEditorModel, false, CancellationToken.None);

          case 11:
            return _context2.abrupt("return", _context2.sent);

          case 12:
            _context2.prev = 12;
            reference.dispose();
            return _context2.finish(12);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8,, 12, 15]]);
  }));
});